import {
	Component,
	ElementRef,
	HostListener,
	Input,
	OnInit,
	QueryList,
	ViewChild,
	ViewChildren,
	ChangeDetectionStrategy,
} from "@angular/core"
import { COMMON_IMPORTS } from "../common-imports"
import { Modalable } from "@app/Modalable"
import { LangValPipe } from "@app/utils/lang-val.pipe"
import { DateFormatPipe } from "@app/utils/date-format.pipe"
import { ModalWrapComponent } from "@app/modal-wrap/modal-wrap.component"
import { GenTableDisplayComponent } from "@app/gen-table-display/gen-table-display.component"

@Component({
	selector: "[row]",
	imports: [
		COMMON_IMPORTS,
		DateFormatPipe,
		ModalWrapComponent,
		GenTableDisplayComponent,
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	template: `
		<div class="colstat-medium ">{{ row.name }}</div>
		<div class="colstat-small ">{{ row.date | dateFormat }}</div>
		<div>
			<button
				titleLang="product_persons"
				tabindex="-1"
				class="btn btn-icon"
				(click)="isModalOpen = true"
			>
				<app-icon icon="mobile" />
			</button>
		</div>
		@if (isModalOpen) {
			<app-modal-wrap
				(onClose)="isModalOpen = false"
				title="contactways"
				modalWrapperClass="modal-wide"
			>
				<app-gen-table-display
					(onClose)="isModalOpen = false"
					tableName="contactways"
					[filterField]="row.person_type + '_id'"
					[filterFieldValue]="row.person_id"
				/>
			</app-modal-wrap>
		}
	`,
})
export class Row {
	isModalOpen: boolean = false
	@Input() row: any
}

@Component({
	selector: "app-product-persons",
	imports: [COMMON_IMPORTS, LangValPipe, Row],
	changeDetection: ChangeDetectionStrategy.Eager,
	template: `
		<div class="text-end">
			<button
				class="btn btn-primary"
				(click)="xlsxDownload()"
			>
				{{ "create_excel" | langVal }}
			</button>
		</div>
		<div>
			@for (row of rows; track row.id) {
				<div
					[row]="row"
					class="d-flex"
				></div>
			}
		</div>
	`,
})
export class ProductPersonsComponent extends Modalable {
	@Input() objectRow: any = null
	rows: any[] = []

	async ngOnInit() {
		const id = this.objectRow.id
		this.rows = this.store
			.getSiteDataTable("product_persons")
			.filter((it) => it.product_id == id)
			.map((row) => {
				const tblName = row.person_type === "patient" ? "patients" : "contacts"
				const id = `${row.person_type}-${row.person_id}`
				return {
					...row,
					id: id,
					name: this.store.searchSiteDataItem(row.person_id, [tblName])?.name,
					date: row.created_at,
				}
			})
	}
	async xlsxDownload() {
		this.store.downloadToastFunc(async () => {
			const res = await this.apiService.download("download_product_persons", {
				id: this.objectRow.id,
			})
			if (!res?.size) {
				return this.store.downloadFailedModal()
			}
			this.apiService.downloadFile(res, `product_perosns.xlsx`)
		})
	}
}
